import { render, staticRenderFns } from "./ContainerTrucking.vue?vue&type=template&id=befcbee2"
import script from "./ContainerTrucking.vue?vue&type=script&lang=js"
export * from "./ContainerTrucking.vue?vue&type=script&lang=js"
import style0 from "./ContainerTrucking.vue?vue&type=style&index=0&id=befcbee2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports